import { useEffect, useRef, useState } from "react";

import GuestImg from "../../assets/images/conversations/Guest-blank.webp";
import ThumbImg from "../../assets/images/conversations/blank.png";
import PlayIcon  from "../../assets/icons/conversations/play-icon.svg";

/* ─────────────────────────────────────────────
   PREFIX: zm-
───────────────────────────────────────────── */
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&family=Roboto:wght@400;500&display=swap');

  *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }

  .zm-page {
    background: #1A1A1A;
    min-height: 100vh;
    font-family: 'Roboto', sans-serif;
    color: #fff;
  }

  .zm-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding-left: 102px;
    padding-right: 102px;
  }

  /* ══════════════════════════════════════
     SECTION 1 - HERO
  ══════════════════════════════════════ */
  .zm-hero {
    padding-top: 60px;
    padding-bottom: 60px;
  }
  .zm-hero__grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;
    align-items: start;
  }
  .zm-hero__left {
    display: flex;
    flex-direction: column;
    gap: 44px;
  }
  .zm-hero__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    line-height: 140%;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .zm-hero__title.zm-visible {
    opacity: 1;
    transform: translateY(0);
  }
  .zm-hero__spotify {
    border-radius: 12px;
    overflow: hidden;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.18s, transform 0.7s ease 0.18s;
  }
  .zm-hero__spotify.zm-visible {
    opacity: 1;
    transform: translateY(0);
  }
  .zm-hero__spotify iframe {
    display: block;
    width: 100%;
    height: 152px;
    border: none;
    border-radius: 12px;
  }
  .zm-hero__right {
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.1s, transform 0.7s ease 0.1s;
  }
  .zm-hero__right.zm-visible {
    opacity: 1;
    transform: translateY(0);
  }

  /* thumbnail */
  .zm-yt-thumb {
    position: relative;
    width: 100%;
    border-radius: 12px;
    overflow: hidden;
    cursor: pointer;
    display: block;
    background: #000;
  }
  .zm-yt-thumb img {
    width: 100%;
    height: auto;
    display: block;
    border-radius: 12px;
    transition: opacity 0.3s ease;
  }
  .zm-yt-thumb:hover img { opacity: 0.85; }
  .zm-yt-thumb__play {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: none;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
  }
  .zm-yt-thumb__play img {
    width: 40px;
    height: 44px;
  }
  .zm-yt-iframe-wrap {
    position: relative;
    width: 100%;
    padding-bottom: 56.25%;
    height: 0;
    border-radius: 12px;
    overflow: hidden;
  }
  .zm-yt-iframe-wrap iframe {
    position: absolute;
    top: 0; left: 0;
    width: 100%; height: 100%;
    border: none;
  }

  /* ══════════════════════════════════════
     SECTION 2 - BODY
  ══════════════════════════════════════ */
  .zm-body {
    padding-bottom: 100px;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .zm-body.zm-visible { opacity: 1; transform: translateY(0); }
  .zm-body__para {
    font-family: 'Roboto', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #E2E2E2;
    line-height: 160%;
    margin-bottom: 14px;
  }
  .zm-body__para:last-child { margin-bottom: 0; }

  /* ══════════════════════════════════════
     SECTION 3 - OUR GUEST (1 guest)
  ══════════════════════════════════════ */
  .zm-guest {
    padding-bottom: 100px;
    text-align: center;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .zm-guest.zm-visible { opacity: 1; transform: translateY(0); }
  .zm-guest__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 50px;
    font-weight: 700;
    color: #ffffff;
    margin-bottom: 60px;
  }
  .zm-guest__photo-bg {
    display: inline-block;
    width: 445px;
    height: 500px;
    background: #743FAC;
    border-radius: 12px;
    overflow: hidden;
  }
  .zm-guest__photo-bg img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: top center;
    display: block;
  }
  .zm-guest__name {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    margin-top: 24px;
  }

  /* ── TABLET (max 768px) ── */
  @media (max-width: 768px) {
    .zm-inner { padding-left: 32px; padding-right: 32px; }
    .zm-hero { padding-top: 32px; padding-bottom: 48px; }
    .zm-hero__grid { grid-template-columns: 1fr 1fr; gap: 24px; }
    .zm-hero__title { font-size: 24px; }
    .zm-hero__left { gap: 16px; }
    .zm-guest__title { font-size: 24px; margin-bottom: 24px; }
    .zm-guest__photo-bg { width: 260px; height: 300px; }
    .zm-guest__name { font-size: 24px; margin-top: 18px; }
    .zm-body__para { font-size: 14px; margin-bottom: 12px; }
    .zm-body { padding-bottom: 48px; }
    .zm-guest { padding-bottom: 48px; }
    .zm-yt-thumb__play img { width: 30px; height: 32px; }
  }

  /* ── MOBILE (max 480px) ── */
  @media (max-width: 480px) {
    .zm-inner { padding-left: 16px; padding-right: 16px; }
    .zm-hero { padding-top: 51px; padding-bottom: 30px; }
    .zm-hero__grid { grid-template-columns: 1fr; gap: 40px; }
    .zm-hero__left { gap: 30px; }
    .zm-hero__title { font-size: 30px; }
    .zm-body__para { font-size: 16px; margin-bottom: 10px; }
    .zm-guest__title { font-size: 30px; margin-bottom: 20px; text-align:left; }
    .zm-guest__photo-bg { width: 100%; height: 386px; }
    .zm-guest__name { font-size: 24px; text-align: left; margin-top: 14px; }
    .zm-body { padding-bottom: 30px; }
    .zm-guest { padding-bottom: 30px; }
    .zm-yt-thumb__play img { width: 30px; height: 32px; }
  }
`;

/* ─────────────────────────────────────────────
   FADE-UP HOOK
───────────────────────────────────────────── */
function useFadeUp(ref) {
  useEffect(() => {
    if (!ref.current) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("zm-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
}

/* ─────────────────────────────────────────────
   YOUTUBE EMBED
───────────────────────────────────────────── */
const YT_VIDEO_ID = "YOUTUBE_VIDEO_ID";

function YouTubeEmbed() {
  const [playing, setPlaying] = useState(false);

  if (playing) {
    return (
      <div className="zm-yt-iframe-wrap">
        <iframe
          src={`https://www.youtube.com/embed/${YT_VIDEO_ID}?autoplay=1&rel=0`}
          title="EP 66 Zohra Mutabanna"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }

  return (
    <div className="zm-yt-thumb" onClick={() => setPlaying(true)} role="button" aria-label="Play video">
      <img src={ThumbImg} alt="EP 66 Zohra Mutabanna thumbnail" />
      <div className="zm-yt-thumb__play">
        <img src={PlayIcon} alt="Play" />
      </div>
    </div>
  );
}

/* ─────────────────────────────────────────────
   SECTIONS
───────────────────────────────────────────── */
function HeroSection() {
  const titleRef   = useRef(null);
  const spotifyRef = useRef(null);
  const rightRef   = useRef(null);

  useFadeUp(titleRef);
  useFadeUp(spotifyRef);
  useFadeUp(rightRef);

  return (
    <section className="zm-hero">
      <div className="zm-inner">
        <div className="zm-hero__grid">
          <div className="zm-hero__left">
            <h1 ref={titleRef} className="zm-hero__title">
              EP 66 | Designing Cities for People, Not Just Cars: Rethinking Urban Mobility with Zohra MUTABANNA
            </h1>
            <div ref={spotifyRef} className="zm-hero__spotify">
              <iframe
                src="https://open.spotify.com/embed/episode/7HfFi80XmM9ROhhjvBX3nW?utm_source=generator&theme=0"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
                title="EP 66 Spotify Player"
              />
            </div>
          </div>
          <div ref={rightRef} className="zm-hero__right">
            <YouTubeEmbed />
          </div>
        </div>
      </div>
    </section>
  );
}

function BodySection() {
  const ref = useRef(null);
  useFadeUp(ref);

  return (
    <section ref={ref} className="zm-body">
      <div className="zm-inner">
        <p className="zm-body__para">
          Designing Cities for People, Not Just Cars: Rethinking Urban Mobility with Zohra MUTABANNA
        </p>
        <p className="zm-body__para">
          What happens when we plug electric vehicles into cities that were never built for them? Urban designer Zohra Mutabanna joins us to unpack the real design challenges of India's mobility future...from shared transport to the Avoid-Shift-Improve model, and how our cities can evolve into living, breathing ecosystems instead of chaotic grids.
        </p>
        <p className="zm-body__para">
          Welcome to the Energising India Podcast. On this program, we engage with the key protagonists shaping the future of energy, mobility, and sustainability within India and globally. I'm your host, Ravin MIRCHANDAN, and today we step into the world of cities, the spaces that hold our daily lives together yet often crack under the weight of growth, congestion, and unsustainable planning. Today, we speak with Zohra MUTABANNA, an architect, urban designer, and thought leader who believes that cities must be designed as ecosystems, not afterthoughts. She works with the intersection of design, policy, and sustainability, asking bold questions about whether India's cities are truly ready for electric mobility or whether we risk building EVs into an already broken urban fabric. Zohra brings years of experience reimagining the built environment through resilience, inclusivity, and innovation. With her, we'll explore the Avoid-Shift and improve framework,the realities of urban transport and shared mobility, and design choices that will determine whether our urban future is chaotic or truly sustainable.
        </p>
      </div>
    </section>
  );
}

function GuestSection() {
  const ref = useRef(null);
  useFadeUp(ref);

  return (
    <section ref={ref} className="zm-guest">
      <div className="zm-inner">
        <h2 className="zm-guest__title">Our Guest</h2>
        <div>
          <div className="zm-guest__photo-bg">
            <img src={GuestImg} alt="Zohra Mutabanna" />
          </div>
          <p className="zm-guest__name">Zohra MUTABANNA</p>
        </div>
      </div>
    </section>
  );
}

/* ─────────────────────────────────────────────
   ROOT
───────────────────────────────────────────── */
export default function Ep66ZohraMutabanna() {
  return (
    <>
      <style>{CSS}</style>
      <div className="zm-page">
        <HeroSection />
        <BodySection />
        <GuestSection />
      </div>
    </>
  );
}